<style>
@import '../../custom/css/admin-navigation.css';

.stats-shopkeeper {
  background: #EFEDED;
  padding: 10px;
}
.icon-stats {
  margin-left: 19px;
}
.stats-bar {
  background: #ABA9AA;
  width: 200px;
  height: 7px;
}
.position-text {
  margin-top: -25px !important;
  position: absolute;
}
.btn-allow {
  margin-top: 10px;
  margin-left: 180px;

}
.bgSucess {
  background: #07DC2A !important;
}
.content-stats {
  background: #ABA9AA;
  width: 50px;
  height: 50px;
}
.risk {
  text-decoration: line-through;
  color: green;
  cursor: pointer;
}
.red {
  color: red;
  cursor: pointer;
}
.painelButton {
  position: fixed;
  z-index: 9;
  top: 5px;
  color: white;
  border: none;
}
.brandAlign {
  margin-left: 95px;
  margin-bottom: 20px;
}
.menuStatus {
  margin-left: 350px ;
}
@media screen and (min-width: 991px) {
  .menuView {
    margin-left: 415px;
    margin-top: 60px;
    overflow-x: hidden;
  }
}
</style>

<template>
  <div class="lojista">
    <b-container class="mb-4 mt-5 pt-3" v-if="barStatsState == true && status != 1">
      <div :class="painelAdm ? 'menuStatus mt-4' : 'mt-4'">
        <b-row  align-h="center">
          <b-col cols="12">
            <h5 class="text-center mb-3">Status de solicitação do aplicativo </h5>
          </b-col>
          <b-col class=" d-flex mt-2 ml-2">
            <div class="content-stats rounded-circle" :class="[appSolicitation.statsReview == true ? 'bgSucess' : null]" ><i class="fas fa-mobile-alt mt-3 icon-stats fs-20 c-white"></i></div>
            <span class="stats-bar rounded mt-4 ml-2" :class="[appSolicitation.statsReview == true ? 'bgSucess' : null]"><span class="position-text">App solicitado</span></span>
          </b-col>
          <b-col class=" d-flex mt-2">
            <div class="content-stats rounded-circle ml-2" :class="[appSolicitation.awaitAuth == true ? 'bgSucess' : null]"><i class="fas fa-home mt-3 ml-3 fs-20 c-white"></i></div>
            <span class="stats-bar rounded mt-4 ml-2" :class="[appSolicitation.awaitAuth == true ? 'bgSucess' : null]"><span class="position-text">Aguardando customização</span></span>
          </b-col>
          <b-col class=" d-flex mt-2">
            <div class="content-stats rounded-circle ml-2" :class="[appSolicitation.appAvailabling == true ? 'bgSucess' : null]"><i class="fas fa-shopping-bag mt-3 ml-3 fs-20 c-white"></i></div>
            <span class="stats-bar rounded mt-4 ml-2" :class="[appSolicitation.appAvailabling == true ? 'bgSucess' : null]"><span class="position-text">Solicitado para publicar</span></span>
          </b-col>
          <b-col class=" d-flex mt-2">
            <div class="content-stats rounded-circle ml-2" :class="[appSolicitation.appFinalization == true ? 'bgSucess' : null]"><i class="fas fa-check-circle mt-3 ml-3 fs-20 c-white"></i></div>
            <span class="mt-2 ml-2">Aplicativo publicado</span>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal
      title="Dados para contato"
      size="md"
      id="finnalyApp"
      :no-close-on-backdrop="windowWidth > 991 ? true : false"
      centered
      hide-header
      hide-footer
    >
      <modal-finnaly-app></modal-finnaly-app>
      <b-button @click="hideStatsBarApp()" class="bg-success btn-allow btn-lg">Prosseguir</b-button>
    </b-modal>
    <b-row no-gutters>
      <b-col cols="12">
        <b-navbar toggleable fixed>
          <div class="painelButton">
            <b-button class="ml-3 mt-2" v-b-toggle.painelAdm variant="outilene" style="color:#FFF">
              <i class="fas fa-bars fs-30"></i>
            </b-button>
          </div>
          <b-sidebar
            v-model="painelAdm"
            id="painelAdm"
            shadow
            width="400px"
            :no-close-on-route-change="windowWidth > 991 ? true : false"
          >
            <b-navbar-brand>
              <div class="brandAlign">
                <img
                  src="@/assets/img/Logo Novo ConstrUp.png"
                  alt="Logo Constr Up"
                  width="180"
                />
              </div>
            </b-navbar-brand>
            <b-navbar-nav>
              <div class="p-2 bg-gray-1 pl-3">
                <div v-if="(!appSolicitation.appAvailabling && status == 3 && modalValid == true) || demoApp" class="ml-2">
                  <div v-if="!validation">

                    <Topic
                      class="mt-2"
                      text="Disponibilizar App"
                      icon="fa fa-mobile"
                    />
                    <ul>
                      <li @click="redirect('lojista-produtos-selecao')" :class="[appValidation.qtdeProduct >=5 ? 'risk': 'red']">Mínimo 5 Produtos cadastrados</li>
                      <li @click="redirect('lojista-app-meios-pagamentos')" :class="[appValidation.formPayment == true ? 'risk': 'red']">Definir regra de recebimento</li>
                      <li @click="redirect('lojista-customizacoes-sobre-empresa')" :class="[appValidation.logo == true ? 'risk': 'red']">Inserir logo do App</li>
                      <li @click="redirect('lojista-customizacoes-sobre-empresa')" :class="[appValidation.icon == true ? 'risk': 'red']">Inserir icone do App</li>
                      <li @click="redirect('lojista-customizacoes-sobre-empresa')" :class="[appValidation.about == true ? 'risk': 'red']">Incluir texto sobre a empresa</li>
                      <li @click="redirect('lojista-customizacoes-mudar-cor')" :class="[appValidation.appCustomization == true ? 'risk': 'red']">Definir cor do App</li>
                      <li @click="redirect('lojista-customizacoes-banners')" :class="[appValidation.banner == true ? 'risk': 'red']">Incluir banner</li>
                      <li @click="redirect('lojista-customizacoes-criar-categoria')" :class="[appValidation. oneCategory== true ? 'risk': 'red']">Criar ao menos uma oferta</li>
                      <li @click="redirect('lojista-customizacoes-criar-categoria')" :class="[appValidation.menuCategory == true ? 'risk': 'red']">Ter no mínimo 2 produtos na oferta</li>
                      <li @click="redirect('lojista-customizacoes-redes-sociais')" :class="[appValidation.whatsapp == true ? 'risk': 'red']">Inserir número do whatsapp</li>
                      <li @click="redirect('lojista-frete-app')" :class="[appValidation.freights == true ? 'risk': 'red']">Definir regra de frete</li>
                      <li @click="redirect('lojista-iugu-dash')" :class="[appValidation.iugu == true ? 'risk': 'red']">Criar conta Iugu e validar</li>
                    </ul>
                  </div>
                  <button
                    class="btn bg-orange fs-20 font-weight-bold mb-4 ml-3 mt-3"
                    @click="$bvModal.show('availableApp')"
                    :disabled="!validation"
                    v-if="modalValid == true"
                  >
                  Disponibilizar App
                  </button>
                </div>

                <Topic :text="'Informações'" :icon="'fas fa-user-circle'" class="mt-3" />
                <BasicItem
                  :text="'Meus Dados'"
                  :icon="'fas fa-list-alt'"
                  :routeName="'lojista-meus-dados'"
                />
                <div v-if="response.message == null"></div>
                <div v-else>
                  <BasicItem
                    :text="'Minha carteira'"
                    :icon="'fas fa-wallet'"
                    :routeName="'lojista-iugu-dash'"
                  />
                </div>
                <BasicItem
                  :text="'Minha Conta'"
                  :icon="'fas fa-user'"
                  :routeName="'lojista-iugu-update'"
                />
                <BasicItem
                  v-if="validaPagamento == true"
                  :text="'Minha assinatura'"
                  :icon="'fas fa-hand-holding-usd'"
                  :routeName="'lojista-iugu-assinatura'"
                />
                <BasicItem
                  v-if="(requestApp == false) || (demoApp == true)"
                  :text="demoApp == true ? 'Contratar assinatura' : 'Solicitar App/Site'"
                  :icon="'fas fa-mobile'"
                  :routeName="demoApp == true && solicitation.plano_id && solicitation.plano_id != '1' ?
                  'lojista-cartão-credito-app-ass' : 'lojista-assinatura-app-site'"
                  />
                <BasicItem
                  :icon="'fas fa-at'"
                  :routeName="'lojista-artes-redes-sociais'"
                  :text="'Artes para redes sociais'"
                />
                <BasicItem
                  v-if="voltarLogin == true"
                  :icon="'fas fa-sign-out-alt'"
                  :routeName="'simular-acesso-lojista-gerente'"
                  :text="'Voltar login de gerente'"
                />
                <BasicItem
                  :text="'Sair'"
                  :icon="'fas fa-power-off'"
                  :routeName="'sair'"
                />
                <Modal />
                <Topic
                  isSectionWeb
                  text="Construp"
                  icon="fas fa-home"
                  class="my-4"
                  v-if="activeConstrup == true"
                  @click="menuConditionWeb"
                />
                <div class="ml-4" v-if="openAppSectionConstrup">
                  <Topic
                    class="mt-4"
                    :text="'Orçamentos'"
                    :icon="'fas fa-clipboard-list'"
                  />
                  <Item
                    :icon="'fas fa-paper-plane'"
                    :count="cotacoesContagem.recebidas"
                    :pushToRouteName="'lojista-recebidas'"
                    :itemText="'Recebidos'"
                    :iconStyle="'transform: rotate(190deg)'"
                  />
                  <Item
                    :icon="'fas fa-paper-plane'"
                    :count="cotacoesContagem.enviadas"
                    :pushToRouteName="'lojista-enviadas'"
                    :itemText="'Enviados'"
                    :iconStyle="'transform: rotate(15deg)'"
                  />
                  <Item
                    :icon="'fas fa-calendar-times'"
                    :count="cotacoesContagem.perdidas"
                    :pushToRouteName="'lojista-perdidas'"
                    :itemText="'Perdidos'"
                  />
                  <!-- Rejeitado -->
                  <Topic
                    class="mt-4"
                    :text="'Orçamentos Rejeitados'"
                    :icon="'fas fa-times-circle'"
                  />
                  <Item
                    :icon="'fas fa-thumbs-down'"
                    :count="cotacoesContagem.rejeitadasPU"
                    :pushToRouteName="'lojista-rejeitadas-pelo-usuario'"
                    :itemText="'Por você'"
                  />
                  <Item
                    :icon="'fas fa-times'"
                    :count="cotacoesContagem.rejeitadasPC"
                    :pushToRouteName="'lojista-rejeitadas-pelos-clientes'"
                    :itemText="'Pelos Clientes'"
                  />
                  <!-- Começo Pedidos -->
                  <Topic
                    class="mt-4"
                    :text="'Pedidos'"
                    :icon="'fas fa-clipboard-check'"
                  />
                  <Item
                    :icon="'fas fa-stopwatch'"
                    :count="cotacoesContagem.aguardando"
                    :pushToRouteName="'aguardando-aprovacao'"
                    :itemText="'Aguardando aprovação'"
                  />
                  <Item
                    :icon="'fas fa-trophy'"
                    :count="cotacoesContagem.ganhas"
                    :pushToRouteName="'lojista-ganhas'"
                    :itemText="'Pedidos aprovados'"
                  />
                  <Item
                    :icon="'fas fa-check-square'"
                    :count="cotacoesContagem.completas"
                    :pushToRouteName="'lojista-completas'"
                    :itemText="'Pedidos Entregues'"
                  />
                  <b-modal
                    title="Disponibilizar Aplicativo"
                    size="md"
                    id="availableApp"
                    header-bg-variant="orange"
                    header-text-variant="light"
                    centered
                    hide-footer>
                      <available-app
                        @validModal="getLink()"
                      >
                      </available-app>
                  </b-modal>
                </div>
                <b-spinner
                  v-if="loadingIfHasApp"
                  class="mx-auto my-4"
                  label="Spinning"
                ></b-spinner>
                <!-- MEU APP -->
                <Topic
                  isSectionApp
                  text="Meu e-commerce"
                  icon="fa fa-mobile"
                  class="my-4 cursor-pointer"
                  :validAssinatura="validAssinatura"
                  v-if="(hasApp && !loadingIfHasApp) || (demoApp == true)"
                  @click="menuConditionApp"
                />
                <div class="ml-4" v-if="(hasApp && openAppSection && validAssinatura) || (demoApp == true)">
                  <Topic
                    text="Início"
                    icon="fas fa-home"
                    pushToRouteName="lojista-home"
                  />
                  <Topic
                    class="mt-4"
                    text="Ver meu App"
                    icon="fas fa-mobile-alt"
                    pushToRouteName="lojista-ver-app"
                  />
                  <Topic
                    class="mt-4"
                    text="Estatísticas"
                    icon="fas fa-chart-line"
                    pushToRouteName="lojista-app-estatisticas"
                  />
                  <!-- Pedidos -->
                  <Topic
                    class="mt-4"
                    text="Pedidos"
                    icon="fas fa-list-alt"
                    pushToRouteName="lojista-pedidos-app"
                  />
                  <Topic
                    class="mt-4"
                    text="Orçamentos"
                    icon="fas fa-hand-holding-usd"
                    pushToRouteName="orcamento-realizado"
                  />
                  <Topic
                    v-if="dadosUsuario.id == 4485 || dadosUsuario.id == 3848 || dadosUsuario.id == 4618"
                    class="mt-4"
                    text="Orçamentos Whatsapp"
                    icon="fab fa-whatsapp"
                    pushToRouteName="orcamento-whatsapp"
                  />
                  <Topic
                    class="mt-4"
                    text="Carrinho abandonado"
                    icon="fas fa-cart-plus"
                    pushToRouteName="carrinho-abondonado"
                  />
                  <Topic
                    class="mt-4"
                    text="Colaboradores"
                    icon="fas fa-user-tie"
                    pushToRouteName="balconista-app"
                  />
                  <Topic
                    class="mt-4"
                    text="Tipos de clientes"
                    pushToRouteName="lojista-app-tipo-clientes"
                    icon="fas fa-users-cog"
                  />
                  <Topic
                    class="mt-4"
                    text="Clientes"
                    pushToRouteName="lojista-clientes"
                    icon="fas fa-users"
                  />

                  <!-- Parceiros -->
                  <!-- !Opção apenas p/ lojista Cardoso(4471) -->
                    <span v-if="hasPermission()">
                      <Topic class="mt-4" text="Parceiros" icon="fas fa-handshake" />
                      <Item
                        icon="fas fa-stream"
                        pushToRouteName="lojista-parceiros-cadastrados"
                        itemText="Parceiros cadastrados"
                        hideCountBadge
                      />
                      <Item
                        icon="fas fa-wallet"
                        pushToRouteName="lojista-carteira-parceiros"
                        itemText="Carteira parceiros"
                        hideCountBadge
                      />
                      <Item
                        icon="fas fa-money-check-alt"
                        pushToRouteName="lojista-custo-produtos"
                        itemText="Custo de Produtos"
                        hideCountBadge
                      />
                    </span>
                  <!-- !Fim da opção -->

                  <!-- Produtos -->
                  <Topic class="mt-4" text="Produtos" icon="fas fa-th-list" />
                  <Item
                    icon="fas fa-tasks"
                    pushToRouteName="lojista-produtos-selecao"
                    itemText="Selecionar produtos"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-check-double"
                    pushToRouteName="lojista-produtos-selecionados"
                    itemText="Produtos selecionados"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-lightbulb"
                    pushToRouteName="lojista-produtos-suggest"
                    itemText="Sugerir produtos"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-box-open"
                    pushToRouteName="lojista-produtos-insert"
                    itemText="Cadastrar produtos"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-tools"
                    pushToRouteName="lojista-service-insert"
                    itemText="Serviços"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-hourglass-half"
                    pushToRouteName="lojista-wainting-product"
                    itemText="Aguardando produtos"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-edit"
                    pushToRouteName="lojista-edit-category"
                    itemText="Editar categoria"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-th-large"
                    pushToRouteName="lojista-variation-product"
                    itemText="Grade de Produto"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-cart-plus"
                    pushToRouteName="lojista-best-sellers"
                    itemText="Produtos mais comprados"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-search"
                    pushToRouteName="lojista-product-search"
                    itemText="Produtos buscados"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-rocket"
                    pushToRouteName="lojista-product-boost"
                    itemText="Impulsionar produtos"
                    hideCountBadge
                  />
                  <!-- Meios de pagamento -->
                  <Topic
                    class="mt-4"
                    text="Meios de pagamento"
                    icon="fas fa-credit-card"
                    pushToRouteName="lojista-app-meios-pagamentos"
                  />
                  <Topic
                    class="mt-4"
                    text="Cupom de desconto"
                    icon="fas fa-ticket-alt"
                    pushToRouteName="lojista-app-cupom-desconto"
                  />
                  <Topic
                    class="mt-4"
                    text="Cupom de cashback"
                    icon="fas fa-coins"
                    pushToRouteName="lojista-app-cupom-cashback"
                  />
                  <Topic
                    v-if="methodWalletShopkeeper"
                    class="mt-4"
                    text="Carteira Cliente"
                    icon="fas fa-wallet"
                    pushToRouteName="lojista-app-carteira"
                  />
                  <!-- Customizações -->
                  <Topic class="mt-4" text="Customizações" icon="fas fa-cog" />
                  <Item
                    icon="fas fa-align-left"
                    pushToRouteName="lojista-customizacoes-sobre-empresa"
                    itemText="Sobre a empresa"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-clock"
                    pushToRouteName="lojista-customizacoes-horario-funcionamento"
                    itemText="Horário Funcionamento"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-palette"
                    pushToRouteName="lojista-customizacoes-mudar-cor"
                    itemText="Mudar cor"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-image"
                    pushToRouteName="lojista-customizacoes-banners"
                    itemText="Banners"
                    hideCountBadge
                  />
                   <Item
                    icon="fas fa-book-open"
                    pushToRouteName="lojista-customizacoes-flyers"
                    itemText="Panfletos"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-align-justify"
                    pushToRouteName="lojista-customizacoes-criar-categoria"
                    itemText="Oferta(s) home"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-hashtag"
                    pushToRouteName="lojista-customizacoes-redes-sociais"
                    itemText="Contato e redes sociais"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-hashtag"
                    pushToRouteName="lojista-customizacoes-destaques"
                    itemText="Destaques"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-share-alt"
                    pushToRouteName="lojista-customizacoes-linktree"
                    itemText="Meus Links"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-ad"
                    pushToRouteName="lojista-app-promocoes-digitais"
                    itemText="Promoções digitais"
                    hideCountBadge
                  />
                  <Item
                    icon="fab fa-facebook"
                    pushToRouteName="lojista-pixel-facebook"
                    itemText="Pixel Facebook"
                    hideCountBadge
                  />
                  <Item
                    icon="fab fa-google"
                    pushToRouteName="lojista-ferramentas-analise"
                    itemText="Ferramentas de análise"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-file-alt"
                    pushToRouteName="lojista-termos-condicoes"
                    itemText="Termos e condições"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-lock"
                    pushToRouteName="lojista-privacidade"
                    itemText="Privacidade"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-shipping-fast"
                    pushToRouteName="lojista-politica-devolucao"
                    itemText="Política de devolução"
                    hideCountBadge
                  />

                  <Topic
                    pushToRouteName="lojista-frete-app"
                    class="mt-4"
                    text="Frete e entrega"
                    icon="fas fa-truck"
                  />

                  <Topic
                    pushToRouteName="lojista-campanha-sorteio"
                    class="mt-4"
                    text="Sorteio"
                    icon="fas fa-dice"
                  />

                  <!-- Promoções -->
                  <div v-if="dadosUsuario && dadosUsuario.id && dadosUsuario.id == 3848 || dadosUsuario.id == 4402">
                    <Topic class="mt-4" text="Promoções" icon="fas fa-tag" />
                    <Item
                      icon="fas fa-align-left"
                      pushToRouteName="lojista-minhas-regras"
                      itemText="Campanhas"
                      hideCountBadge
                    />
                    <!-- <Item
                      icon="fas fa-gifts"
                      pushToRouteName="lojista-meus-premios"
                      itemText="Prêmios"
                      hideCountBadge
                    /> -->
                    <Item
                      icon="fas fa-tags"
                      pushToRouteName="lojista-premios-solicitados"
                      itemText="Prêmios solicitados"
                      hideCountBadge
                    />
                  </div>

                  <Topic class="mt-4" text="Notificações" icon="fas fa-bell" pushToRouteName=""
                  />
                  <Item
                    icon="fas fa-paper-plane"
                    pushToRouteName="lojista-app-notificacoes"
                    itemText="Enviar notificações"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-solid fa-bell"
                    pushToRouteName="lojista-app-notificacoes-cms"
                    itemText="Enviar notificações App"
                    hideCountBadge
                  />
                  <Item
                    icon="fab fa-whatsapp"
                    pushToRouteName="lojista-app-notificacoes-whatsapp"
                    itemText="Notificações do WhatsApp"
                    hideCountBadge
                  />
                  <Item
                    v-if="dadosUsuario.id == 4479"
                    icon="fas fa-newspaper"
                    pushToRouteName="newsletter-app-notificacoes"
                    itemText="Newsletter"
                    hideCountBadge
                  />
                  <Topic
                    v-if="solicitationApp.agent_ia"
                    class="mt-4 mb-4"
                    text="Agente de IA"
                    icon="fas fa-robot"
                    pushToRouteName="lojista-app-agente-ia"
                  />
                  <Topic
                    class="mt-4 mb-4"
                    text="Solicitações de profissionais"
                    icon="fas fa-tasks"
                    pushToRouteName="lojista-app-profissionais-solicitacoes"
                  />
                  <b-row>
                    <Topic class="mt-1" text="Página em construção" icon="fas fa-hard-hat" />
                    <b-form-checkbox
                      v-model="isConstruct"
                      @change="openUderConstructionModal()"
                      class="mt-2 ml-3"
                      switch
                    >
                    </b-form-checkbox>
                  </b-row>
                  <Topic
                    class="mt-4"
                    text="Relatórios"
                    icon="fas fa-file-alt"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-hashtag"
                    pushToRouteName="lojista-report-facebook-ads"
                    itemText="Facebook Ads"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-globe"
                    pushToRouteName="lojista-report-google-analytics"
                    itemText="Google Analytics"
                    hideCountBadge
                  />
                  <Item
                    icon="fab fa-whatsapp"
                    pushToRouteName="lojista-report-whatsapp-clicks"
                    itemText="Qtd. clicks WhatsApp"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-share-alt"
                    pushToRouteName="lojista-report-linktree-clicks"
                    itemText="Qtd. clicks contatos"
                    hideCountBadge
                  />
                  <Topic
                    class="mt-4"
                    text="Integrações"
                    icon="fab fa-connectdevelop"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-lock"
                    pushToRouteName="lojista-integrar-api-product"
                    itemText="API ConstrUp"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-network-wired"
                    pushToRouteName="lojista-app-webhooks"
                    itemText="Webhooks"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-store"
                    pushToRouteName="lojista-app-marketplaces"
                    itemText="Marketplaces"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-laptop-house"
                    pushToRouteName="lojista-app-erp"
                    itemText="ERPs"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-sync"
                    pushToRouteName="lojista-app-tiny"
                    itemText="Tiny"
                    hideCountBadge
                  />
                  <Item
                    icon="far fa-credit-card"
                    pushToRouteName="lojista-app-anti-fraud"
                    itemText="Antifraude"
                    hideCountBadge
                  />
                  <Item
                    icon="fas fa-tags"
                    pushToRouteName="lojista-google-shopping"
                    itemText="Google Shopping"
                    hideCountBadge
                  />
                </div>
              </div>
            </b-navbar-nav>
          </b-sidebar>
      </b-navbar>
    </b-col>
    <!-- CONTEUDO -->
    <b-col :class="painelAdm ? 'menuView' : 'mx-4 mt-5'">
      <router-view />
    </b-col>
    </b-row>

    <b-modal
      title="Disponibilizar Aplicativo"
      size="md"
      id="availableApp"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <available-app
          @validModal="getLink()"
        >
        </available-app>
    </b-modal>
    <UnderConstructionModal
      ref="underConstructionModal"
      @getModal="getConstruct()"
      @inConstruction="isActiveSwitch()"
      :inConstruct="isConstruct"
      :idShopkeeper="dadosUsuario"
    />


  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { CoolSelect } from 'vue-cool-select';
import Item from '../../components/Menu/Item.vue';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';
import Modal from './firstLogin/Modal.vue';
import ModalFinnalyApp from "./ModalFinnalyApp.vue";
import AvailableApp from '@/components/AvailableApp.vue';
import makeToast from '../../mixins/makeToast';
import UnderConstructionModal from './UnderConstructionModal.vue';
import ShopkeepersEnum from '@/enums/ShopkeepersEnum';

export default {
  name: 'lojista',
  mixins: [makeToast],
  data() {
    return {
      ShopkeepersEnum,
      validAssinatura: true,
      voltarLogin: false,
      validaPagamento: false,
      windowWidth: window.innerWidth,
      painelAdm: false,
      modalValid: true,
      isSlowCotacao: true,
      isSlowDados: true,
      response: [],
      barStatsState: false,
      status: null,
      hideModalApp: ['7'],
      openAppSection: false,
      hasApp: false,
      demoApp: false,
      activeConstrup: false,
      solicitationApp: null,
      solicitation: '',
      openAppSectionConstrup: false,
      loadingIfHasApp: false,
      requestApp: false,
      validation: false,
      appValidation: {
        logo: false,
        icon: false,
        qtdeProduct:0,
        formPayment: false,
        about: false,
        appCustomization: false,
        whatsapp: false,
        banner: false,
        oneCategory: false,
        freights: false,
        iugu: false,
        menuCategory: false
      },
      methodWalletShopkeeper: false,
      validStatusApp: false,
      appSolicitation: {
        statsReview: false,
        awaitAuth: false,
        appAvailabling: false,
        appFinalization: false
      },
      isConstruct: false,
    };
  },
  components: {
    Item,
    Topic,
    BasicItem,
    Modal,
    ModalFinnalyApp,
    AvailableApp,
    UnderConstructionModal
  },

  computed: {
    ...mapState({
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoesContagem: (state) => state.cotacoesContagem,
    }),
  },
   mounted() {
    window.addEventListener("resize", this.handleResize);
    this.widthWindow();
    this.$root.$on('valid-status-app', () => {
      this.verifyApp();
    });
    this.$root.$on('valid-available-app', () => {
      this.showIugu();
    });
    this.getConstruct();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    const gerente = JSON.parse(localStorage.getItem('voltarLogin'))
    if(gerente && gerente == true) {
      this.voltarLogin = true;
    }

    this.verifyApp();
    this.isVisible();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getPaymentMethods',
      'validationApp',
      'getModCosntruct'
    ]),

    openUderConstructionModal() {
      this.$refs.underConstructionModal.toggleOpen();
    },

    isActiveSwitch() {
      this.isConstruct = !this.isConstruct;
    },

    getConstruct() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getModCosntruct({userId: this.dadosUsuario.id})
        .then((response) => {
          this.isConstruct = response.data.under_construction == 1 ? true : false;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 991) this.painelAdm = true;
    },
    widthWindow() {
      if (this.windowWidth > 991) this.painelAdm = true;
    },
    redirect(value) {
      this.$router.push({ name: value });
    },
    validationAppResponse() {
      this.validationApp(this.dadosUsuario.id)
        .then((response) => {
          const webhook = response.data.webhook;
          localStorage.setItem('webhook', webhook);

          this.appValidation.logo = response.data.logo;
          this.appValidation.icon = response.data.icon;
          this.appValidation.qtdeProduct = response.data.qtdeProduct;
          this.appValidation.formPayment = response.data.formPayment;
          this.appValidation.about = response.data.about;
          this.appValidation.appCustomization = response.data.appCustomization;
          this.appValidation.whatsapp = response.data.whatsapp;
          this.appValidation.banner = response.data.banner;
          this.appValidation.freights = response.data.freights;
          this.appValidation.oneCategory = response.data.oneCategory;
          this.appValidation.menuCategory = response.data.menuCategory;
          this.appValidation.iugu = !(this.response.message && this.response.message.last_verification_request_status == null);
          if(
            this.appValidation.logo == true &&
            this.appValidation.icon == true &&
            this.appValidation.qtdeProduct >= 5 &&
            this.appValidation.formPayment == true &&
            this.appValidation.about == true &&
            this.appValidation.appCustomization == true &&
            this.appValidation.whatsapp == true &&
            this.appValidation.banner == true &&
            this.appValidation.freights == true &&
            this.appValidation.oneCategory == true &&
            this.appValidation.iugu == true &&
            this.appValidation.menuCategory == true
          ){
            this.validation = true;
          }
        })
        .finally(() => {
        });
    },

    getMethoPayment() {
      this.$store.dispatch('startLoader');
      this.getPaymentMethods(this.dadosUsuario.id)
        .then((response) => {
          response.data.data.forEach(element => {
            if(element.type == 4 && element.enabled == 1)
            this.methodWalletShopkeeper = true;
          });
        })
        .catch(() => {})
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    getLink() {
      this.modalValid = false;
      this.statsBarApp();
    },

    statsBarApp() {
      this.$store.dispatch('startLoader');
        this.$store.dispatch('getAppShopkeeperById', this.dadosUsuario.informacoes.id)
        .then((resp) => {
          const {data} = resp;

          this.status = data.status;
          if(data.status >= 1) {
            this.appSolicitation.statsReview = true;
            this.barStatsState = true;
          }
          if(data.status >= 3) {
            this.appSolicitation.statsReview = true;
            this.appSolicitation.awaitAuth = true;
          }
          if(data.status >= 4) {
            this.appSolicitation.appAvailabling = true;
            this.appSolicitation.statsReview = true;
            this.appSolicitation.awaitAuth = true;
          }
          if(data.status >= 6) {
            this.appSolicitation.appFinalization = true;
            this.appSolicitation.appAvailabling = true;
            this.appSolicitation.statsReview = true;
            this.appSolicitation.awaitAuth = true;
            if(data.status == 6) {
              this.$bvModal.show('finnalyApp');
            }
          }
          if(data.status == 7) {
            this.appSolicitation.appFinalization = true;
            this.appSolicitation.appAvailabling = true;
            this.appSolicitation.statsReview = true;
            this.appSolicitation.awaitAuth = true;
            this.$bvModal.hide('finnalyApp');
            this.barStatsState = false;
          }
        })
        .catch(() => {
            this.makeToast('Ops!', 'Infelizmente ocorreu um erro, favor tentar novamente!!!', 'danger');
        })
        .finally(()=>{
          this.$store.dispatch('endLoader');
        });
    },
    hideStatsBarApp() {
      const objData = {
          id: this.dadosUsuario.informacoes.id,
          status: '7'
        }
      this.$store.dispatch('startLoader');
        this.$store
        .dispatch('updateShopkeeperStatus', objData)
        .then(() => {
            this.$bvModal.hide('finnalyApp');
            barStatsState = false;
        })
        .catch(() => {
          this.makeToast('Ops!',  'Infelizmente ocorreu um erro, favor tentar novamente!!!','danger' );
        })
        .finally(()=>{
          this.$store.dispatch('endLoader');
        });
    },

    ...mapActions('shopkeeper', ['verifyIfHasApp']),
    contagemCotacoes() {
      this.$store.dispatch('showContagemCotacoes', this.dadosUsuario);
    },
    openUserTypeModal() {
      this.$bvModal.show('firstlogin');
    },

    menuConditionWeb() {
      this.openAppSectionConstrup = !this.openAppSectionConstrup;
      if(this.openAppSectionConstrup == false) {
        this.openAppSectionConstrup = false;
        localStorage.removeItem("menuStateWeb");
      }
      if (this.openAppSectionConstrup == true) {
      localStorage.setItem("menuStateWeb", true)
      this.openAppSectionConstrup = true;
    }
    },

    menuConditionApp() {
      if(this.validAssinatura == false) {
        this.makeToast('Ops!',  'Para acessar os dados do App, é necessário realizar o pagamento da assinatura!','danger' );
        if(this.$route.name != 'lojista-cartão-credito-app-ass') {
          this.$router.push({ name: 'lojista-cartão-credito-app-ass' });
        }
        return;
      }

      this.openAppSection = !this.openAppSection;
      if(this.openAppSection == false) {
        this.openAppSection = false;
        localStorage.removeItem("menuStateApp");
      }
      if (this.openAppSection == true) {
        localStorage.setItem("menuStateApp", true)
        this.openAppSection = true;
      }
    },

    showIugu() {
      this.$store.dispatch('showInfoDashboard')
        .then((resp) => {
          this.response = resp.data;

          if(resp.data.assinatura.verificaAss && resp.data.assinatura.verificaAss == true) {
            if(resp.data.assinatura.status && resp.data.assinatura.status != 2) {
              this.validAssinatura = false;
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.response = null;
          }
        }).finally(() => {
          this.validationAppResponse();
        })
    },
    getVerificaSolicitacao() {
      const dados = {
        id : this.dadosUsuario.informacoes.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('verificaSolicitacao', dados)
        .then((response) => {
          this.validaPagamento = response.data.validaPagamento;

          if(response.data.assinaturaExterna == false) {
            this.validaPagamento = true;
          }

          this.requestApp = false;
          if(response.data.validApp){
            this.requestApp = true;
            this.statsBarApp();
          }
        })
        .finally(()=>{
          this.$store.dispatch('endLoader');
        });
    },
    getVerifyIfHasApp() {
      this.verifyIfHasApp(this.dadosUsuario.informacoes.id)
        .then((response) => {
          const { hasApp, demoApp, activeConstrup, solicitation, solicitationApp } = response.data || {};

          this.hasApp = hasApp || false;
          this.demoApp = demoApp || false;
          this.activeConstrup = activeConstrup || false;
          this.solicitation = solicitation || '';
          this.solicitationApp = solicitationApp || null;
        })
        .catch(() => {
          this.hasApp = false;
        })
        .finally(() => {
          this.loadingIfHasApp = false;
        });
    },
    verifyApp(){
      if (this.dadosUsuario) {
        this.showIugu();
        this.contagemCotacoes();
      }

      this.getMethoPayment();

      this.openAppSectionConstrup = localStorage.getItem("menuStateWeb");
      this.openAppSection = localStorage.getItem("menuStateApp");
      this.loadingIfHasApp = true;

      this.getVerifyIfHasApp();
      this.getVerificaSolicitacao();
    },
    hasPermission(){
      if(this.dadosUsuario.id == ShopkeepersEnum.WEBCONSTRUP ||
        this.dadosUsuario.id == ShopkeepersEnum.CARDOSO
      ) return true;
      return false;
    },
  },
};
</script>
